import ReactGA from "react-ga4";

export function trackEvent(name, params = {}) {
  if (process.env.NODE_ENV !== "production") return;
  if (!process.env.REACT_APP_GA_TRACKING_ID) return;

  try {
    ReactGA.event(name, params);
  } catch (e) {}
}